import * as React from 'react';
const DisidrosiDiManiEPiediIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M94.83 146.4c0-4.3-.11-11.4-1.72-12.03-17.61-6.87-16.03-25.06-30.92-36.09 6.87-12.03 19.75 10.31 24.05 10.31 5.44-15.9-9.88-46.4 0-46.4 4.01 0 7.93 25.32 11.22 25.32s-.7-33.92 7.67-33.92c6.87 0 .36 29.2 4.51 33.35 5.44-.14 3.08-28.19 12.67-28.19 6.01 0-3.95 31.68 0 30.93 3 0 8.3-20.62 13.74-20.62 1.82 0 1.82 1.55 1.72 3.99-.34 8.32-8.59 27-8.59 30.38 0 9.88-1 22.34-6.87 30.93-2.25 3.29-1.72 12.03-1.72 12.03"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="M116.91 100.16c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M107.26 104.34c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M115.46 110.58c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M97.78 109.78c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M108.74 122.31a2.78 2.78 0 0 0 1.83-3.48 2.78 2.78 0 0 0-3.48-1.83 2.78 2.78 0 0 0-1.83 3.48 2.78 2.78 0 0 0 3.48 1.83"
      className="prefix__cls-1"
    />
  </svg>
);
export default DisidrosiDiManiEPiediIcon;
